import React, { useEffect, useState } from "react";
import { postRequestAuthenticated } from "../../services/rest";

// Compact URL preview (unfurl) card shown under a chat message. Fetches the
// server-side metadata once from the SSRF-guarded /unfurl endpoint and renders
// nothing while loading or when there's no usable preview.
const LinkPreview = ({ url }) => {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    let active = true;
    if (!url) return undefined;
    postRequestAuthenticated("/unfurl", { url })
      .then((res) => {
        if (active && res?.success && res.preview) setPreview(res.preview);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [url]);

  if (!preview || !(preview.title || preview.description || preview.image)) {
    return null;
  }

  return (
    <a
      href={preview.url || url}
      target="_blank"
      rel="noopener noreferrer"
      className="flex my-1 w-max max-w-full overflow-hidden rounded-lg border border-theme-chatDivider bg-theme-tertiaryBackground no-underline"
    >
      {preview.image && (
        <img
          src={preview.image}
          alt=""
          className="h-16 w-16 flex-shrink-0 object-cover"
          loading="lazy"
        />
      )}
      <div className="flex min-w-0 flex-col justify-center px-3 py-2">
        {preview.siteName && (
          <span className="truncate text-[0.7rem] text-theme-secondaryText opacity-70">
            {preview.siteName}
          </span>
        )}
        {preview.title && (
          <span className="truncate text-sm font-medium text-theme-primaryText">
            {preview.title}
          </span>
        )}
        {preview.description && (
          <span className="line-clamp-2 text-xs font-light text-theme-secondaryText">
            {preview.description}
          </span>
        )}
      </div>
    </a>
  );
};

export default LinkPreview;
